module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-chart-wrapper"
  }, [_c('div', {
    staticClass: "total-amount"
  }, [_vm._v("\n    总销售额："), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("formatMoney")(_vm.totalAmount)) + " 元")])]), _vm._v(" "), (!_vm.categoryData.length) ? _c('div', {
    staticClass: "empty-tip"
  }, [_vm._v("\n    暂无数据可展示\n  ")]) : _c('div', {
    ref: "categoryChart",
    staticStyle: {
      "height": "350px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c53c4582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/CategoryPie.vue
// module id = 1036
// module chunks = 3